"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = CrossLarge;

var _CrossLarge = require("@adobe/react-spectrum-ui/dist/CrossLarge");

var _icon = require("@react-spectrum/icon");

var _react = _interopRequireDefault(require("react"));

function CrossLarge(props) {
  return /*#__PURE__*/_react.default.createElement(_icon.UIIcon, props, /*#__PURE__*/_react.default.createElement(_CrossLarge.CrossLarge, null));
}